module.exports = __webpack_public_path__ + "img/2018-12-16-3.9ee76ebc.jpeg";